<template>
  <h2 class="title">{{ title }}</h2>
</template>

<script>
export default {
  name: "TitleVue",
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.title {
  font-family: "Montserrat";
  font-size: var(--fs-title);
  color: var(--color-text);
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 3.625rem;
}

.title::after {
  content: "";
  display: block;
  margin: 0 auto;
  width: 24px;
  height: 3px;
  background: var(--color-text);
}
</style>
